import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import plugins from './plugins/index' // 插件引入
import './configs/autoFix' // 不同屏幕分辨率适配
import './commonStyle/index.scss' // 全局公共样式
import './configs/element' // 按需引入element组件
import './configs/ant' // 按需引入ant design组件
import Icon from './components/Icon/Icon' // 自定义图标组件
import Dialog from './components/Dialog/Dialog' // 全局对话框组件
import Empty from './components/Empty/Empty' // 全局空状态组件
import Empty2 from './components/Empty/Empty2' // 全局空状态组件
import directives from './directive'
import { OpenPeerChannel, SimpleMessageEventSource } from '@/libs/open-peer-channel'

window.localStorage.setItem('API_BASE_URL', process.env.VUE_APP_API_BASE_URL)
Vue.config.productionTip = false
Vue.use(plugins)
Vue.component('Icon', Icon)
Vue.component('Dialog', Dialog)
Vue.component('Empty', Empty)
Vue.component('Empty2', Empty2)
Vue.use(directives)

new Vue({
  router,
  store,
  render: h => h(App),
  provide: () => {
    const channel = new OpenPeerChannel({
      parent: SimpleMessageEventSource()
    })
    channel.register({
      $store: store
    })
    channel.register({
      $channel: channel
    })
    return {
      channel
    }
  }
}).$mount('#app')

window.initStoreState = JSON.parse(JSON.stringify(store.state))
// console.log('shine-meta-pc create OpenPeerChannel')
// const channel = new OpenPeerChannel({
//   parent: window.parent
// })
// channel.message((msg) => {
//   console.log('shine-meta-pc 接收到：', msg)
// })
// console.log(channel.id, channel)
